import { MDX } from "./mdx/tokens";
import { motion, useReducedMotion } from "framer-motion";
import ObondoDashboardPreview from "./ObondoDashboardPreview";

/**
 * HeroSectionMdx — centered title + subtitle + CTAs above the two animated
 * mobile mockups.
 */
export default function HeroSectionMdx({ isDark, onStartTrial }) {
    const bg = isDark ? "bg-[#090D16]" : "bg-white";
    const text = isDark ? "text-[#F9FAFB]" : "text-[#090D16]";
    const outlineBrd = isDark ? "border-[#1F2937]" : "border-[#E5E7EB]";
    const reduceMotion = useReducedMotion();
    const enter = reduceMotion
        ? {}
        : {
            initial: { opacity: 0, y: 16 },
            animate: { opacity: 1, y: 0 },
            transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] },
        };

    return (
        <section className={`${bg} ${text} pt-14 md:pt-20 pb-16 md:pb-24`} data-testid="hero-mdx">
            <div className="max-w-[1400px] mx-auto px-4 md:px-8">
                <div className="grid xl:grid-cols-2 gap-10 xl:gap-14 items-center">
                    {/* Left · headline + subtitle + CTAs — vertically centred with the phones */}
                    <motion.div {...enter}>
                        <h1
                            className="font-inter font-bold leading-[1.05] tracking-tight"
                            style={{ fontSize: "clamp(43px, 5vw, 63px)" }}
                            data-testid="hero-h1"
                        >
                            Learn To Trade African Shares And Money — Risk-Free.
                        </h1>
                        <h2
                            className="font-inter font-medium mt-5 leading-tight"
                            style={{ fontSize: "clamp(20px, 2.6vw, 28px)", color: MDX.blueLow }}
                            data-testid="hero-h2"
                        >
                            Real market prices. Virtual money. Built for beginners across Africa.
                        </h2>

                        <div className="mt-8 flex flex-col sm:flex-row gap-3">
                            <button
                                onClick={onStartTrial}
                                data-testid="hero-primary-cta"
                                style={{ background: MDX.greenCtaSolid }}
                                onMouseEnter={(e) => (e.currentTarget.style.background = MDX.greenHov)}
                                onMouseLeave={(e) => (e.currentTarget.style.background = MDX.greenCta)}
                                className="font-inter font-bold uppercase tracking-wider text-[17px] rounded-md px-6 py-3 text-white transition duration-150 hover:shadow-lg hover:-translate-y-0.5 active:scale-[0.98]"
                            >
                                Start 7-Day Free Trial
                            </button>
                        </div>
                    </motion.div>

                    {/* Right · animated phones */}
                    <ObondoDashboardPreview isDark={isDark} />
                </div>
            </div>
        </section>
    );
}
